import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { SERVER_URL } from '../../config';
import { Form, Input, Button, notification } from 'antd';
import { EyeFilled, EyeInvisibleFilled } from '@ant-design/icons';
import { Section } from '../../components/content';
import { AXIOS_API_CALL } from '../../utils/endpoint';

const ResetPassword = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [resetBtnLoader, setResetBtnLoader] = useState(false);

  const onFinish = async (data) => {
    setResetBtnLoader(true);
    const token = id;
    const newPassword = data['new-password'];
    const confirmPassword = data['confirm-password'];

    const dataPayload = {
      password: newPassword
    };

    if (newPassword.includes(confirmPassword) && confirmPassword.includes(newPassword)) {
      try {
        const fetchPasswordReset = await axios.post(`${SERVER_URL}/${AXIOS_API_CALL.passwordReset}/${token}`, { ...dataPayload }, { withCredentials: false });

        if (fetchPasswordReset.status === 200) {
          notification.success({
            message: 'Password was successfully reset.',
            placement: 'topRight'
          });

          navigate(AXIOS_API_CALL.login, { replace: true });
        }
        setTimeout(() => {
          setResetBtnLoader(false);
        }, 200);
      } catch (err) {
        notification.warn({
          message: err.response.data.message,
          placement: 'topRight'
        });
        setTimeout(() => {
          setResetBtnLoader(false);
        }, 200);
        navigate(AXIOS_API_CALL.login, { replace: true });
      }
    } else {
      notification.warn({
        message: 'New password or confirm password is not equal!',
        placement: 'topRight'
      });
      setTimeout(() => {
        setResetBtnLoader(false);
      }, 200);
    }
  };

  const onFinishFailed = (err) => {
    console.error(err);
  };

  return (
    <Section className="section section__login section__new-password">
      <div className="container-fluid">
        <div className="card-wrapper form-wrapper">
          <div className="d-flex justify-center items-center mb-4 gap-x-1">
            <img className="login-circle" src="/assets/icons/password-reset.svg" alt="Login" />
            <h1 className="mb-0">Postavi novu lozinku</h1>
          </div>

          <div className="d-flex justify-center items-center">
            <p className="subtitle">
              Nova lozinka mora biti drugačija <br /> od prošle
            </p>
          </div>

          <Form name="reset-password" onFinish={onFinish} onFinishFailed={onFinishFailed}>
            <label className="label" htmlFor="new-password">
              Nova lozinka:
            </label>
            <Form.Item name="new-password" rules={[{ required: true, message: 'Molimo vas unesite novu lozinku!' }]}>
              <Input.Password iconRender={(visible) => (visible ? <EyeFilled /> : <EyeInvisibleFilled />)} placeholder="Nova lozinka" id="new-password" />
            </Form.Item>

            <label className="label" htmlFor="confirm-password">
              Potvrdi lozinku:
            </label>
            <Form.Item name="confirm-password" rules={[{ required: true, message: 'Molimo vas potvrdite novu lozinku!' }]}>
              <Input.Password iconRender={(visible) => (visible ? <EyeFilled /> : <EyeInvisibleFilled />)} placeholder="Potvrdi lozinku" id="confirm-password" />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0, paddingTop: '20px' }}>
              {!resetBtnLoader ? (
                <Button type="primary" className="btn btn-block btn-primary btn-no-focus" htmlType="submit">
                  Promeni Lozinku
                </Button>
              ) : (
                <Button type="primary" className="btn btn-block btn-primary-outline" htmlType="button">
                  Promena...
                </Button>
              )}
            </Form.Item>

            <Form.Item style={{ paddingTop: '40px' }}>
              <Link to="/login" className="link link-primary text-center d-flex items-center gap-x-1">
                <img src="/assets/icons/arrow.svg" alt="Button Back" />
                <span>Nazad na ptijavu</span>
              </Link>
            </Form.Item>
          </Form>
        </div>
      </div>
    </Section>
  );
};

export default ResetPassword;
